import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { editRouteQuery, getFullPath } from '@/utils/url'
import { getAuthUrl } from '@/utils/ww-jssdk'

const index = () => import(/* webpackChunkName: "index" */ '../pages/index/index.vue')

const orderPay = () => import(/* webpackChunkName: "acpe" */ '../pages/acpe/orderPay.vue')

const inquiryDetail = () => import(/* webpackChunkName: "inquiryDetail" */ '../pages/inquiryDetail/index.vue')

const appAgreementIndex = () => import(/* webpackChunkName: "appAgreement" */ '../pages/appAgreement/index.vue')
const appAgreementIndex1 = () => import(/* webpackChunkName: "appAgreement" */ '../pages/appAgreement/index1.vue')
const appAgreementIndex2 = () => import(/* webpackChunkName: "appAgreement" */ '../pages/appAgreement/index2.vue')
const appAgreementIndex3 = () => import(/* webpackChunkName: "appAgreement" */ '../pages/appAgreement/index3.vue')
const appAgreementIndex4 = () => import(/* webpackChunkName: "appAgreement" */ '../pages/appAgreement/index4.vue')
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/memberEnquiryIndex',
      name: 'memberEnquiryIndex',
      component: () => import(/* webpackChunkName: "appAgreement" */ '../pages/memberEnquiry/index.vue'),
      meta: {
        title: 'VIP会员查询权益'
      }
    },
    {
      path: '/feeDeductionIndex',
      name: 'feeDeductionIndex',
      component: () => import(/* webpackChunkName: "appAgreement" */ '../pages/feeDeduction/index.vue'),
      meta: {
        title: '具体扣费细则'
      }
    },
    {
      path: '/appAgreement1Index',
      name: 'appAgreement1Index',
      component: () => import(/* webpackChunkName: "appAgreement" */ '../pages/appAgreement1/index.vue'),
      meta: {
        title: '袋鼠低碳隐私政策'
      }
    },
    {
      path: '/appAgreement1Index1',
      name: 'appAgreement1Index1',
      component: () => import(/* webpackChunkName: "appAgreement" */ '../pages/appAgreement1/index1.vue'),
      meta: {
        title: '袋鼠低碳隐私条款'
      }
    },
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: ''
      }
    },
    {
      path: '/appAgreementIndex',
      name: 'appAgreementIndex',
      component: appAgreementIndex,
      meta: {
        title: '袋鼠保协议'
      }
    },
    {
      path: '/appAgreementIndex1',
      name: 'appAgreementIndex1',
      component: appAgreementIndex1,
      meta: {
        title: '袋鼠保'
      }
    },
    {
      path: '/appAgreementIndex3',
      name: 'appAgreementIndex3',
      component: appAgreementIndex3,
      meta: {
        title: '袋鼠低碳'
      }
    },
    {
      path: '/appAgreementIndex4',
      name: 'appAgreementIndex4',
      component: appAgreementIndex4,
      meta: {
        title: '袋鼠低碳特别提示'
      }
    },
    {
      path: '/appAgreementRecycle',
      name: 'appAgreementRecycle',
      component: () => import('../pages/appAgreementRecycle/index.vue'),
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/appAgreementRecycle1',
      name: 'appAgreementRecycle1',
      component: () => import('../pages/appAgreementRecycle/index1.vue'),
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/appAgreementRecycle2',
      name: 'appAgreementRecycle2',
      component: () => import('../pages/appAgreementRecycle/index2.vue'),
      meta: {
        title: '袋鼠回收'
      }
    },
    {
      path: '/appAgreementRecycleAboutUs',
      name: 'appAgreementRecycleAboutUs',
      component: () => import('../pages/appAgreementRecycle/aboutUs.vue'),
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/appAgreementIndex2',
      name: 'appAgreementIndex2',
      component: appAgreementIndex2,
      meta: {
        title: '袋鼠保'
      }
    }, {
      path: '/acpe/orderPay',
      name: 'orderPay',
      component: orderPay,
      meta: {
        title: '太保支付'
      }
    },
    {
      path: '/download',
      name: 'download',
      component: () => import(/* webpackChunkName: "download" */ '../pages/download/index.vue'),
      meta: {
        title: '下载页'
      }
    },
    {
      path: '/recycleDownload',
      name: 'recycleDownload',
      component: () => import(/* webpackChunkName: "recycleDownload" */ '../pages/recycleDownload/index.vue'),
      meta: {
        title: '回收下载页'
      }
    },
    {
      path: '/inquiryDetail',
      name: 'inquiryDetail',
      component: inquiryDetail,
      meta: {
        title: '配件清单'
      }
    },
    {
      path: '/inquiryDetailR',
      name: 'inquiryDetailR',
      component: () => import(/* webpackChunkName: "inquiryDetailR" */ '../pages/inquiryDetailR/index.vue'),
      meta: {
        title: '配件清单'
      }
    },
    {
      path: '/inquiryDetailS',
      name: 'inquiryDetailS',
      component: () => import(/* webpackChunkName: "inquiryDetailR" */ '../pages/inquiryDetailS/index.vue'),
      meta: {
        title: '袋鼠保平台供货清单'
      }
    },
    {
      path: '/inquiryDetailRDetail',
      name: 'inquiryDetailRDetail',
      component: () => import(/* webpackChunkName: "inquiryDetailRDetail" */ '../pages/inquiryDetailR/detail.vue'),
      meta: {
        title: '配件清单'
      }
    },
    {
      path: '/electronicLetterH5',
      name: 'electronicLetterH5',
      component: () => import(/* webpackChunkName: "blankPage" */'../components/blankPage'),
      children: [
        {
          path: '',
          name: 'electronicLetterH5Index',
          component: () => import(/* webpackChunkName: "electronicLetterH5" */'../pages/electronicLetter/H5'),
          meta: { title: '电子函' }
        },
        {
          path: 'check',
          name: 'electronicLetterH5Check',
          component: () => import(/* webpackChunkName: "electronicLetterH5Check" */'../pages/electronicLetter/H5/check'),
          meta: { title: '确认电子函' }
        },
        {
          path: 'signature',
          name: 'electronicLetterH5Signature',
          component: () => import(/* webpackChunkName: "electronicLetterH5Signature" */'../pages/electronicLetter/H5/signature'),
          meta: { title: '在线签名' }
        },
        {
          path: 'templateDetail',
          name: 'templateDetailH5',
          component: () => import(/* webpackChunkName: "electronicLetterTemplate" */'../pages/electronicLetter/common/electronicLetterTemplate'),
          meta: { title: '电子函模板详情' }
        }
      ]
    },
    {
      path: '/electronicLetterApp',
      name: 'electronicLetterApp',
      component: () => import(/* webpackChunkName: "blankPage" */'../components/blankPage'),
      children: [
        {
          path: 'home',
          name: 'electronicLetterApp',
          component: () => import(/* webpackChunkName: "electronicLetterApp" */'../pages/electronicLetter/App'),
          meta: { title: '电子函' }
        },
        {
          path: 'detail',
          name: 'electronicLetterAppDetail',
          component: () => import(/* webpackChunkName: "electronicLetterAppDetail" */'../pages/electronicLetter/App/detail'),
          meta: { title: '电子函详情' }
        },
        {
          path: 'templateDetail',
          name: 'templateDetail',
          component: () => import(/* webpackChunkName: "electronicLetterTemplate" */'../pages/electronicLetter/App/templateDetail'),
          meta: { title: '电子函模板详情' }
        },
        {
          path: 'create',
          name: 'electronicLetterAppCreate',
          component: () => import(/* webpackChunkName: "electronicLetterAppCreate" */'../pages/electronicLetter/App/create'),
          meta: { title: '创建电子函' }
        },
        {
          path: 'preview',
          name: 'electronicLetterAppPreview',
          component: () => import(/* webpackChunkName: "electronicLetterAppPreview" */'../pages/electronicLetter/App/preview'),
          meta: { title: '电子函详情' }
        }
      ]
    },
    {
      path: '/noNetworkPage',
      name: 'noNetworkPage',
      component: require('../pages/electronicLetter/common/errPage').default,
      meta: {
        title: '电子函详情'
      }
    },
    {
      path: '/decode-clue',
      name: 'decode-clue',
      component: () => import(/* webpackChunkName: "decode-clue" */'../pages/decode-clue'),
      meta: {
        title: '译码线索'
      },
      children: [
        {
          path: '/decode-clue/draw',
          name: 'decode-clue_draw',
          component: () => import(/* webpackChunkName: "decode-clue_draw" */'../pages/decode-clue/draw'),
          meta: { title: '译码线索领取' }
        },
        {
          path: '/decode-clue/detail',
          name: 'decode-clue_detail',
          component: () => import(/* webpackChunkName: "decode-clue_detail" */'../pages/decode-clue/detail'),
          meta: { title: '译码线索详情' }
        },
        {
          path: '/decode-clue/feedback',
          name: 'decode-clue_feedback',
          component: () => import(/* webpackChunkName: "decode-clue_feedback" */'../pages/decode-clue/feedback'),
          meta: { title: '译码线索反馈' }
        }
      ]
    },
    {
      path: '/rpa-inquiry',
      name: 'rpa-inquiry',
      component: () => import(/* webpackChunkName: "rpa-inquiry" */'../pages/rpa-inquiry'),
      meta: {
        title: '询价采购'
      },
      children: [
        {
          path: '/rpa-inquiry/offer',
          name: 'rpa-inquiry_offer',
          component: () => import(/* webpackChunkName: "rpa-inquiry_draw" */'../pages/rpa-inquiry/offer'),
          meta: { title: '询价报价单' }
        },
        {
          path: '/rpa-inquiry/order',
          name: 'rpa-inquiry_order',
          component: () => import(/* webpackChunkName: "rpa-inquiry_order" */'../pages/rpa-inquiry/order'),
          meta: { title: '采购下单' }
        },
        {
          path: '/rpa-inquiry/order-complete',
          name: 'rpa-inquiry_order-complete',
          component: () => import(/* webpackChunkName: "rpa-inquiry_order-complete" */'../pages/rpa-inquiry/order-complete'),
          meta: { title: '采购订单' }
        },
        {
          path: '/rpa-inquiry/supplier-offer',
          name: 'rpa-inquiry_supplier-offer',
          component: () => import(/* webpackChunkName: "rpa-inquiry_supplier-offer" */'../pages/rpa-inquiry/supplier-offer'),
          meta: { title: '供应商报价管理' }
        }
      ]
    },
    {
      path: '/longda-demo',
      name: 'longda-demo',
      component: require('../pages/longda/demo').default,
      meta: {
        title: '品牌查询系统'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 }
  }
})

/** 需要企业微信授权的路由 */
const wwAuthRoute = [
  '/decode-clue',
  '/decode-clue/draw',
  '/decode-clue/detail',
  '/decode-clue/feedback'
]

router.beforeEach(async (to, from, next) => {
  // 需要授权的路由
  if (wwAuthRoute.includes(to.path)) {
    // 兼容授权返回的重定向url（hash路由授权问题处理）
    const matchCode = window.location.href.match(/=(\S*)&state=DAISHUBAO#/)
    // url是否带参数
    const prefix = Object.keys(to.query).length === 0 ? '?' : '&'
    if (matchCode !== null) {
      return location.replace(`${getFullPath(to)}${prefix}code=${matchCode[1]}`)
    }

    const code = to.query.code

    // 未登录 & 未授权
    if (!store.getters['user/isLogin'] && !code) {
      const url = await getAuthUrl(encodeURIComponent(getFullPath(to)))
      // 跳走要求授权
      if (url) {
        return (location.href = url)
      }
    }
    // 未登录 & 已授权
    if (!store.getters['user/isLogin'] && code) {
      // 设置用户信息
      await store.dispatch('user/getUserPhone', code)

      // 去除code
      router.replace(editRouteQuery(to, { code: null, state: null }))
    } else {
      // 已登录，设置用户信息
      await store.dispatch('user/getUserInfo', store.getters['user/userInfo'])
    }
  }

  next()
})

router.afterEach(async (to) => {
  document.title = to.meta.title
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js